<em-product-group-card [group]="data.group" class="p-4"></em-product-group-card>
